module.exports = __webpack_public_path__ + "fonts/9aac12c.woff";